// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"da446c1a","598":"0ada586d","703":"96c2358b"}[chunkId] + ".chunk.js";
};